// @flow

import { toUnicode } from 'punycode.js';

export const divideTldFromBaseDomain: string => {
  baseFqdn: string,
  tld: string | '',
} = fqdn => {
  const splitted = fqdn.split('.');
  let baseFqdn = fqdn;
  let tld = '';
  try {
    const decodedBase = toUnicode(splitted.shift() || '');
    const decodedTld = toUnicode(splitted.join('.'));

    if (decodedBase || decodedTld) {
      baseFqdn = decodedBase;
      tld = decodedTld;
    }
  } catch (e) {
    // Do nothing
  }
  return { baseFqdn, tld };
};
